import React from 'react';
import DottedLoader from '../DottedLoader';
 
const IntermediateMessage = (props) => {

    return (
        <>
        <div className="center-on-screen">
            {props.loading ? <div style={{textAlign: "center"}}>
                <DottedLoader />
            </div> : <div style={{textAlign: "center"}}>
                <img src={props.icon} height={200} width={200}/>
            </div>}
            <div style={{textAlign: "center",margin: "20px auto"}}>
                <h2  className={`manrope f-24 lh-32 w-700 black-085 justify-in-center mb-10 text-center`}>{props.heading}</h2>
                <p className="manrope f-14 lh-22 w-400 black-085 text-center">{props.text}</p>
                {props.buttons}
            </div>
        </div>
        </>
      );
}

export default IntermediateMessage;